import React from "react";

interface IProps {
    socialMediaNetwork: string;
    buttonEvent: any;
}

const ConfirmDeleteSocialMedia: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-unlink"></em>
                </div>
                <h1>Confirm Disconnect</h1>
            </div>

            <div className="dialog-body">
                <p>
                    Are you sure you want to disconnect your <strong>{props.socialMediaNetwork}</strong> account from RepIQ?
                    <br />
                    All data related to the account will be permanently deleted. You can reconnect your account whenever you'd like.
                </p>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => props.buttonEvent("close")}>
                            <span className="btn-text">Cancel</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-red" onClick={() => props.buttonEvent("delete")}>
                            <span className="btn-icon">
                                <em className="las la-trash-alt"></em>
                            </span>
                            <span className="btn-text">Disconnect</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ConfirmDeleteSocialMedia;
